import useRoleEditService, {
  PermissionConfigItemBase,
} from "@/pages/settings/roles/edit/role-edit-service.ts";
import {
  EditRoleSchema,
  EditRoleSchemaInput,
} from "@/pages/settings/roles/edit/use-role-edit-schema.hook.ts";
import { PermissionType } from "@/types/role.types.ts";
import { DropdownMenu, DropdownMenuItem, ListItem, Text } from "@skailer-com/uikit";
import { Control, Controller, UseFormRegister } from "react-hook-form";

export interface RoleEditPermissionFieldProps {
  item: PermissionConfigItemBase;
  register: UseFormRegister<EditRoleSchemaInput>;
  control: Control<EditRoleSchemaInput, unknown, EditRoleSchema>;
}

export function RoleEditPermissionField({ item, control }: RoleEditPermissionFieldProps) {
  const { permissionTypesTexts } = useRoleEditService();

  const getPermissionTypeText = (permissionType: PermissionType): string => {
    return (
      item.customPermissionTypesTexts?.[permissionType] || permissionTypesTexts[permissionType]
    );
  };

  return (
    <ListItem
      layout={"two-columns"}
      preTitle={item.title}
      valueSlot={
        <Controller
          render={({ field: { value, onChange } }) => (
            <DropdownMenu
              trigger={
                <Text
                  className={"underline text-dark/95 cursor-pointer hover:no-underline"}
                  tabIndex={0}
                >
                  {getPermissionTypeText(value as PermissionType)}
                </Text>
              }
            >
              {item.availableOptions.map((option, optionIndex) => (
                <DropdownMenuItem
                  key={`employee-field-permission-option-${optionIndex}`}
                  title={getPermissionTypeText(option)}
                  description={item.availableOptionsDescription?.[option]}
                  isSelected={option == value}
                  onClick={() => {
                    onChange(option);
                  }}
                />
              ))}
            </DropdownMenu>
          )}
          control={control}
          name={item.field as keyof EditRoleSchema}
        />
      }
    />
  );
}
